import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type UserMfaResetFailedAction = {
	type: 'USER_MFA_RESET_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): UserMfaResetFailedAction => ({
	type: 'USER_MFA_RESET_FAILED',
	payload,
});
